var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"min-height":"85vh"},attrs:{"fluid":"","pa-3":""}},[_c('AppProfile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }